import { apiService } from "../services/api";
import type { AppDispatch } from "../state/store";
import { showAlertDialog } from "../state/utils/confirmationDialogUtils";
import { pendingDueLookup } from "./referenceSettlementUtils";

export const BILL_ALLOCATION_BLOCKED_ALERT_TITLE =
  "Bill Wise Allocation Not Allowed";

export type BillAllocationBlockingValidation = {
  allowed: boolean;
  message: string;
};

export const isCustomerBillAllocationContext = (
  screenId?: string | null,
  moduleEndpoint?: string | null
): boolean => {
  const sid = String(screenId || "").trim();
  const module = String(moduleEndpoint || "").trim();
  if (module === "bill_allocations") return true;
  return sid === "188";
};

export const isVendorBillAllocationContext = (
  screenId?: string | null,
  moduleEndpoint?: string | null
): boolean => {
  const sid = String(screenId || "").trim();
  const module = String(moduleEndpoint || "").trim();
  if (module === "vendor_bill_allocations") return true;
  return sid === "193";
};

export const resolveBillAllocationPartyId = (
  partyType: "customer" | "vendor",
  ...sources: Array<Record<string, any> | undefined | null>
): string | undefined => {
  const keys =
    partyType === "customer"
      ? ["customer_id", "drp_customer"]
      : ["vendor_id", "drp_vendor", "supplier_id", "drp_supplier"];
  for (const source of sources) {
    if (!source) continue;
    for (const key of keys) {
      const value = source[key];
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        return String(value).trim();
      }
    }
  }
  return undefined;
};

export async function showBillAllocationBlockedAlert(
  dispatch: AppDispatch,
  message: string
): Promise<void> {
  await showAlertDialog(dispatch, message, BILL_ALLOCATION_BLOCKED_ALERT_TITLE);
}

export async function validateBillAllocationBlockingEntries(
  partyType: "customer" | "vendor",
  partyId: string
): Promise<BillAllocationBlockingValidation> {
  const lookupName = pendingDueLookup(partyType);
  const rows = await apiService.getRawLookupData(lookupName, {
    parentid: partyId,
    lookuptype: "Search_Select",
  });

  if (Array.isArray(rows) && rows.length > 0) {
    return {
      allowed: false,
      message:
        partyType === "customer"
          ? "Bill wise allocation is not allowed while this customer has unadjusted debit (pending due) entries. Settle them in Reference settlement first."
          : "Vendor bill wise allocation is not allowed while this vendor has unadjusted credit entries. Settle them in Reference settlement first.",
    };
  }

  return { allowed: true, message: "" };
}
